import { render, staticRenderFns } from "./reportingCategoryList.vue?vue&type=template&id=bd5017ea&"
import script from "./reportingCategoryList.vue?vue&type=script&lang=js&"
export * from "./reportingCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports